module.exports = __webpack_public_path__ + "Server-Healthy.TentacleActive.1f8d0d2ffd8e58fe8844ecbce562f98e.hashedasset.png";


//////////////////
// WEBPACK FOOTER
// ./app/img/machines/Server-Healthy.TentacleActive.png
// module id = 1252
// module chunks = 1